import * as PropTypes from "prop-types";
import * as React from "react";
import { Color } from "bambu";
import { Message, MessageBody, MessageHeader, MessageProps } from "bambu/lib/components/message/index";

export interface MessageViewProps extends MessageProps {
  header?: string | JSX.Element | JSX.Element[];
  children: any;
  bodyStyle?: React.CSSProperties;
}

const MessageView: React.SFC<MessageViewProps> = (props: MessageViewProps) => {
  const { header, children, bodyStyle, ...messageProps } = props;
  const body = {
    wordBreak: "break-all",
    ...bodyStyle,
  };
  return (
    <Message {...messageProps}>
      {header && <MessageHeader key={"message-header"}>{header}</MessageHeader>}
      <MessageBody style={body} key={"message-body"}>
        {children}
      </MessageBody>
    </Message>
  );
};

MessageView.propTypes = {
  ...Message.propTypes,
  header: PropTypes.string,
} as any;

MessageView.defaultProps = {
  ...Message.defaultProps,
  color: Color.info,
};

export default MessageView;
